// frontend/src/App.js
import React from 'react';
import { AuthProvider } from './components/AuthContext'; // Importa desde la ubicación correcta
import AppRouter from './components/AppRouter';

const App = () => {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
};

export default App;